import {
	GET_ERRORS
} from '../constants/index'

export const getErrors = (payload: Error) => {

  return {
		type: GET_ERRORS,
		payload
	}
}



